import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import AssignPhoneNumberDialog, {
  AssignPhoneNumberDialogCallbackInput,
  AssignPhoneNumberUniqueProps,
} from '../assignPhoneNumberDialog';

const { useDialogForContext, useDialog: useAssignPhoneNumberDialog } =
  getDialogHooks<
    AssignPhoneNumberUniqueProps,
    AssignPhoneNumberDialogCallbackInput
  >(AssignPhoneNumberDialog);
export const useAssignPhoneNumberDialogForContext = useDialogForContext;
export default useAssignPhoneNumberDialog;
